//GeneratorFlag:[NoChange]
import StaticContent from './static-content';
import StaticContentFilter from './static-content-filter';

export default {StaticContent, StaticContentFilter}
export{StaticContent, StaticContentFilter}